(function( $ ) {
    var tabbed_slider = $(".section_tabbed_slider .tabbed_slider"),
        swiper_sliders = [],
        breakpoint = window.matchMedia( '(max-width:575px)' ); // 575;

    if(tabbed_slider.length) {

        slider_initialise();

        $(window).on('resize', function() {
            for(let i=0; i < swiper_sliders.length; i++) {
            //     swiper_sliders[i].destroy();
            swiper_sliders[i].updateSize();
            // swiper_sliders[i].updateSlides()
            }

            slider_initialise();
        });

        $('body').on('click', '.tabbed_slider .tab', function(event) {
            let tabbed_slider = getClosest(event.target, '.tabbed_slider').swiper;
            tabbed_slider.slideTo($(this).index());
        });

    }

    function slider_initialise() {

        for(let i=0; i < tabbed_slider.length; i++) {

            tabbed_slider[i].classList.add("tabbed_slider_" + i);

            let pagination_style, navigation_style,
                style =  parseInt(tabbed_slider[i].dataset.style);

            // prepare slider settings
            if(style == 2) {
                pagination_style = {
                    el: ".swiper-pagination",
                };
                navigation_style = {
                    nextEl: ".tabbed_slider_" + i +' .tabbed-button-next',
                    prevEl: ".tabbed_slider_" + i +' .tabbed-button-prev',
                };
            } else {
                pagination_style = {
                    el: '.swiper-pagination',
                    type: 'custom',
                    clickable: true,
                    renderCustom: function(swiper, current, total) {
                        let titles = [],
                            text = '';

                        $(swiper.$el).find(".swiper-slide").each(function(i) {
                            titles.push($(this).data("title"));
                        });

                        for (let i = 0; i <= total - 1; i++) {
                            text += '<div class="tab'+ ((current == i + 1) ? ' active' : '') +'">'+ titles[i]  +'</div>';
                        }

                        return text;
                    }
                }
            }

            // save each swiper in array
            swiper_sliders[i] = new Swiper(".tabbed_slider_" + i, {
                // allowTouchMove: (style !== 2) ? false : true,
                navigation: (navigation_style) ? navigation_style : false,
                pagination: (pagination_style) ? pagination_style : false,
                speed: 800,
                slidesPerView: "auto",
                spaceBetween: 20,
                // loop: true,
                centeredSlides: true,
                updateOnWindowResize: true,
                breakpoints: {
                    320: {
                    spaceBetween: 0
                    },
                    992: {
                    spaceBetween: 0
                    }
                },
                on: {
                    init: function(swiper) {
                        slider_set_text(swiper);
                    },
                    slideChange: function(swiper) {
                        slider_set_text(swiper);
                    },
                    afterInit: function() {
                        $(".tabbed_slider_" + i)
                            .find('.swiper-wrapper').css('opacity', 1).end()
                            .find('.static_content_wrap').css('opacity', 1);
                    },
                    // resize: function(swiper) {
                    //     if(breakpoint.matches === false) {
                    //         slider_set_text(swiper);
                    //     }
                    // }
                },
            });

            // update sizes of slides
            // swiper_sliders[i].updateSize();
        }

    }

    function slider_set_text(slider_instance) {
        let sl = slider_instance,
            sl_index = sl.activeIndex,
            sl_content = $(sl.$el).find('.static_content_wrap .content');

        if(sl.slides.length) {

            if(sl.slides[sl_index].dataset.title) {
                sl_content.find('h4').text(sl.slides[sl_index].dataset.title);
            }

            if(sl.slides[sl_index].dataset.desc) {
                sl_content.find('p').text(sl.slides[sl_index].dataset.desc);
            }

            if(sl.slides[sl_index].dataset.buttonEnable) {
                sl_content.find('.button_wrapper a')
                    .attr("href", sl.slides[sl_index].dataset.buttonUrl)
                    .text(sl.slides[sl_index].dataset.buttonText)
                    .show();
            } else {
                sl_content.find('.button_wrapper a')
                .attr("href", '')
                .text('')
                .hide();
            }
        }
    }

    /* Helper Function */
    function getClosest(elem, selector) {

        // Element.matches() polyfill
        if (!Element.prototype.matches) {
            Element.prototype.matches =
                Element.prototype.matchesSelector ||
                Element.prototype.mozMatchesSelector ||
                Element.prototype.msMatchesSelector ||
                Element.prototype.oMatchesSelector ||
                Element.prototype.webkitMatchesSelector ||
                function(s) {
                    var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                        i = matches.length;
                    while (--i >= 0 && matches.item(i) !== this) {}
                    return i > -1;
                }
        }

        // Get the closest matching element
        for ( ; elem && elem !== document; elem = elem.parentNode ) {
            if ( elem.matches( selector ) ) return elem;
        }
        return null;

    }

})( jQuery );